import { useMemo, useState } from "react";
import { startOfMonth } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import heLocale from 'date-fns/locale/he';
import 'react-day-picker/dist/style.css';
import MyDateTime from "../DTechComp/MyDateTime";

//בודק אם ליום הנתון יש לפחות slot תקין אחד, בקפיצות 15 דק' כמו
//MyDateTime.generateFutureSlots - אבל עוצר בראשון שנמצא (לוח שנה
//צריך רק בוליאני לכל יום, לא את הרשימה המלאה)
const dayHasAnySlot = (rest, master, dateOnly, channel) => {
    const dayStart = new Date(dateOnly);
    dayStart.setHours(0, 0, 0, 0);
    for (let m = 0; m < 24 * 60; m += 15) {
        const slot = new Date(dayStart.getTime() + m * 60 * 1000);
        if (MyDateTime.isFutureSlotValid(rest, master, slot, channel).ok) return true;
    }
    return false;
};

// לוח שנה לבחירת תאריך להזמנה עתידית, מבוסס על react-day-picker (בדיוק כמו
// DatePick2.js בהזמנת שולחן). מוצג בתוך הפאנל המשותף של FutureOrderPicker,
// בלי כפתור/פופאפ משלו - ה-tab-switching מנוהל אצל ההורה.
// props: rest, master, channel, selectedDate (Date), onSelect(date)
const FutureDatePick = (props) => {

    const [displayedMonth, setDisplayedMonth] = useState(startOfMonth(props.selectedDate || new Date()));

    //ימים חסומים בחודש המוצג בלבד - נמנע מחישוב מחדש על כל render
    const disabledDaysSet = useMemo(() => {
        const set = new Set();
        const monthStart = new Date(displayedMonth);
        const y = monthStart.getFullYear();
        const m = monthStart.getMonth();
        const daysInMonth = new Date(y, m + 1, 0).getDate();
        for (let d = 1; d <= daysInMonth; d++) {
            const day = new Date(y, m, d);
            if (!dayHasAnySlot(props.rest, props.master, day, props.channel)) {
                set.add(day.toDateString());
            }
        }
        return set;
    }, [displayedMonth, props.rest, props.master, props.channel]);

    const isDayDisabled = (day) => disabledDaysSet.has(day.toDateString());

    return (
        <div className={"mydtPicker futureDatePickWrap"}>
            <DayPicker
                mode="single"
                dir="rtl"
                locale={heLocale}
                selected={props.selectedDate}
                modifiers={{ disabled: isDayDisabled }}
                onDayClick={(day, { disabled }) => !disabled && props.onSelect(day)}
                month={displayedMonth}
                onMonthChange={(date) => setDisplayedMonth(startOfMonth(date))}
            />
        </div>
    );
}

export default FutureDatePick;
